export default "__VITE_ASSET__DllXYcQM__"